export const fontVariants = {
  opt1: 'fonts-opt1',
  opt2: 'fonts-opt2',
  opt3: 'fonts-opt3',
};
